<template>
  <v-app id="inspire">
    <template v-if="isAuth">
      <v-navigation-drawer
        :clipped="$vuetify.breakpoint.lgAndUp"
        v-model="drawer"
        fixed
        app>
        <sidebar-block/>
      </v-navigation-drawer>
      <v-toolbar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        color="primary"
        dark
        app
        fixed>
        <v-toolbar-title
          style="width: 300px"
          class="ml-0 pl-3">
          <v-toolbar-side-icon @click.stop="drawer = !drawer"/>
          <span class="hidden-sm-and-down">Elsazeit</span>
        </v-toolbar-title>
        <!--<v-text-field  flat  solo-inverted  hide-details  prepend-inner-icon="search"  :label="$nt('search')"  class="hidden-sm-and-down"/>-->
        <v-spacer/>
        <!--<notification-block/>-->
        <v-toolbar-items v-if="isAuth">
          <v-btn
            flat
            @click="logout">{{ $t('logoutText') }}
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </template>

    <v-content>
      <v-container fluid>
        <v-layout
          column>

          <v-flex xs12>
            <v-alert
              :value="isUnsubscribed"
              type="warning"
            >
              {{ $t('pleaseSubscribe') }}
            </v-alert>
          </v-flex>

          <v-flex xs12>
            <v-alert
              :value="!isUnsubscribed && !isHasCompany && !isEmployee"
              type="info"
            >
              {{ $t('pleaseCreateCompany') }}
              <v-spacer/>
              <v-btn
                :to="{name: 'company.info'}"
                class="ml-0">{{ $t('goToCompanyCreate') }}
              </v-btn>
            </v-alert>
          </v-flex>
          <h1
            v-if="heading"
            class="primary--text mb-3">{{ heading }}</h1>
          <slot/>
          <global-notifications/>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NotificationBlock from '@/components/layouts/parts/NotificationBlock'
import SidebarBlock from '@/components/layouts/parts/SidebarBlock'
import GlobalNotifications from '@/components/layouts/parts/GlobalNotifications'
import setLayoutClass from '@/utils/setLayoutClass'
import '@/styles/webapp/app.scss'

export default {
  name: 'AppLayout',
  components: { GlobalNotifications, SidebarBlock, NotificationBlock },
  props: ['heading'],
  data: () => ({
    dialog: false,
    drawer: null
  }),
  computed: {
    ...mapGetters('user', ['isAuth', 'getUser']),
    isUnsubscribed () {
      return this.getUser.role === 'user'
    },
    isHasCompany () {
      const { has_company } = this.getUser
      return has_company
    },
    isEmployee () {
      const { role } = this.getUser
      return role === 'employee'
    }
  },
  methods: {
    ...mapActions('user', ['logout'])
  },
  mounted () {
    setLayoutClass('layout-webapp')
  },
  i18n: {
    messages: {
      de: {
        pleaseSubscribe: 'Sie haben aktuell ein Testkonto, bitte schließen Sie ein Abonnement ab um die Plattform nutzen zu können. ',
        pleaseCreateCompany: 'Bevor Sie starten, legen Sie bitte ihre Firmendaten fest',
        goToCompanyCreate: 'Firmendaten bearbeiten',
        logoutText: 'Abmelden'
      },
      en: {
        pleaseSubscribe: 'You currently have a test account, please sign up for a subscription to use the platform.',
        pleaseCreateCompany: 'Before you can start, please setup your company data',
        goToCompanyCreate: 'Add company data',
        logoutText: 'Logout'
      },
      tr: {
        pleaseSubscribe: 'Mevcut hesabınız test hesabıdır, platform kullanım üyeliği için lütfen kayıt olunuz.',
        pleaseCreateCompany: 'Başlamadan önce lütfen şirket verilerinizi ayarlayın',
        goToCompanyCreate: 'Şirket verisi ekle',
        logoutText: 'Çıkış'
      },
      ru: {
        pleaseSubscribe: 'В настоящее время у вас тестовый аккаунт, пожалуйста, оформите подписку на использование платформы.',
        pleaseCreateCompany: 'Прежде чем вы сможете начать, пожалуйста, настройте данные вашей компании',
        goToCompanyCreate: 'Добавить данные компании',
        logoutText: 'Выход'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
</style>
